import { j as l } from "../../../jsx-runtime-B6kdoens.js";
import { c as f } from "../../../index-CROKJrb5.js";
import { c as i, f as d } from "../../../create-component-CBAeEoQ6.js";
import { useModalStateAtoms as x } from "../ModalState/index.js";
import { u as t } from "../../../react-B_GApDuV.js";
const A = f({
  base: "cur-order-last cur-flex cur-gap-2 cur-flex-wrap cur-shrink-0 cur-w-full cur-p-2 cur-pt-4 cur-mb-2",
  variants: {
    compact: {
      false: "cur-px-0"
    },
    contentStyle: {
      card: "cur-bg-surface-neutral cur-p-4 cur-mb-4"
    }
  }
}), w = i(
  "ModalFooter",
  d(
    ({ as: o, children: r, className: c, ...e }, a) => {
      const s = o || "div", { compactAtom: m, contentStyleAtom: u } = x(), n = t(m), p = t(u);
      return /* @__PURE__ */ l.jsx(
        s,
        {
          ref: a,
          className: A({
            className: c,
            compact: n,
            contentStyle: p
          }),
          ...e,
          children: r
        }
      );
    }
  )
);
export {
  w as ModalFooter
};
//# sourceMappingURL=index.js.map
